import { render } from "./ProductsList.vue?vue&type=template&id=577fdfcb&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&id=577fdfcb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577fdfcb"]])

export default __exports__